import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enPlayer from '../locales/en/player.json';
import enLibrary from '../locales/en/library.json';
import plCommon from '../locales/pl/common.json';
import plPlayer from '../locales/pl/player.json';
import plLibrary from '../locales/pl/library.json';

const resources = {
  en: {
    translation: {
      ...enCommon,
      ...enPlayer,
      ...enLibrary,
    },
  },
  pl: {
    translation: {
      ...plCommon,
      ...plPlayer,
      ...plLibrary,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'pl'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
